import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { UserService } from '@modules/shared/services/user.service';

import { environment } from '../../../../environments/environment';

@Injectable()
export class PreMediaGuard implements CanActivate {
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate() {
    return this.userService.user$.pipe(
      take(1),
      map((user) => {
        if (user) {
          if (user.hasPreMediaAccess) {
            // redirect to homepage after logout
            this.userService.redirectUrl = environment.frontendUrl;
            return true;
          } else {
            this.router.navigate(['403'], { skipLocationChange: true });
            return false;
          }
        } else {
          this.router.navigate(['401'], { skipLocationChange: true });
          return false;
        }
      })
    );
  }
}
